import React from "react";

function SubmitOrCheckoutButton({ noCheckout, disabled, isSubmitting, orderDate, onSubmit }) {
  const handleClick = () => {
    onSubmit?.(noCheckout ? orderDate : undefined);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || isSubmitting}
      className="bg-primary text-white py-2 px-4 rounded mr-auto ml-auto mt-4 hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {noCheckout && isSubmitting ? "Submitting..." : noCheckout ? "Submit" : "Proceed to checkout"}
    </button>
  );
}

export default SubmitOrCheckoutButton;
